/*
 * 企業側 マイページ コンサルタント選定
 */
import { apiUpdate } from '@/actions/ApiBaseActions';
export const API_UPDATE_CLIENT_MY_PAGE_CONSULTATIONS_DRAFT = 'API_UPDATE_CLIENT_MY_PAGE_CONSULTATIONS_DRAFT';
/**
 * コンサルタント選定 下書き 保存
 * @param data
 * @param meta
 * @returns
 */
export const apiUpdateClientConsultationDraft = ({ json }, meta) => apiUpdate(API_UPDATE_CLIENT_MY_PAGE_CONSULTATIONS_DRAFT, '/client/consultation_draft/update', json, Object.assign({}, meta));
